import { _get, _post } from ".";
// 获取商品列表数据
export const list_good = (data: any) => {
  const req = {
    data,
    url: 'zst/user/common/goodsPage',
  };
  return _post(req);
};
export const getUrl = (url: any) => {
  const req = {
    data: { url },
    url: 'zst/user/common/getFileUrl',
  };
  return _post(req);
};
// 获取商品列表数据
export const list_order = (data: any) => {
  const req = {
    data,
    url: 'zst/page/user/getMyOrder',
  };
  return _get(req);
};
// 退款
export const withdraw = (data: any) => {
  const req = {
    data,
    url: 'zst/page/user/requestRefund',
  };
  return _post(req);
};
// 创建商品订单
export const create_good = (data: any) => {
  const req = {
    data,
    url: 'zst/page/user/createOrder2',
  };
  return _post(req);
};
// 删除订单
export const delete_good = (orderNumber: any) => {
  const data = { orderNumber };
  const req = {
    data,
    url: 'zst/page/user/deleteOrder',
  };
  return _get(req);
};
// 获取商品具体信息
export const data_good = (data: any) => {
  const req = {
    data,
    url: 'zst/user/common/getBayGoods',
  };
  return _get(req);
};
export const pay = (data: any) => {
  const req = {
    data,
    url: 'zst/page/user/webPay/alipay/payment1',
  };
  return _get(req);
};
